// src/pages/BookDetails.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';  // ✅ NEW!
import sampleBooks from '../data/sampleBooks';
import BookCarousel from '../Components/BookCarousel';
import '../styles/BookDetails.css';

const BookDetails = () => {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const book = sampleBooks.find(b => b.id === bookId);

  const [selectedLevel, setSelectedLevel] = useState(book?.cefrLevels?.[0] || "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [bookId]);

  if (!book) return <div>Book not found!</div>;

  const relatedBooks = sampleBooks.filter(
  b =>
    b.id !== book.id &&
    (
      b.genres.some(genre => book.genres.includes(genre))
    )
);


  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/library');
    }
  };

  return (
    <motion.div
      className="book-details-page"
      style={{ background: "linear-gradient(135deg, #0d0d0d 30%, #7c3aed 100%)", minHeight: "100vh" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <div className="hero-section">
        <img src={book.coverImageHorizontal} alt={book.title} className="hero-bg" />
        <div className="hero-overlay" />

        <button className="back-btn" onClick={handleBack} aria-label="Go Back">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="11" stroke="rgba(255,255,255,0.6)" />
            <polyline points="12 8 8 12 12 16" />
            <line x1="16" y1="12" x2="8" y2="12" />
          </svg>
        </button>

        <div className="hero-content">
          <h1>{book.title}</h1>
          <p className="author-name">by {book.author}</p>
          <div className="hero-buttons">
            <button className="primary-btn">Start Reading</button>
            <button className="secondary-btn">Add to My List</button>
          </div>
        </div>
      </div>

      <div className="book-info">
        <div className="book-info-left">
          <p><strong>Summary:</strong> {book.description}</p>
          <p><strong>Genre:</strong> {book.genres.join(", ")}</p>
        </div>
        <div className="book-info-right">
          <label>
            CEFR Level:
            <select value={selectedLevel} onChange={e => setSelectedLevel(e.target.value)}>
              {book.cefrLevels.map(level => (
                <option key={level} value={level}>{level}</option>
              ))}
            </select>
          </label>
          <p><strong>Word Count:</strong> {book.wordCount.toLocaleString()}</p>
          <p><strong>Chaptrs:</strong> {book.chapters}</p>
          <p><strong>Quiz Count:</strong> {book.quizCount}</p>
          <p><strong>Rating:</strong> ⭐ {book.rating} / 5</p>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${book.progress.percent}%` }}
            />
            <span>{book.progress.percent}% Completed</span>
          </div>
        </div>
      </div>

      <div className="related-carousel">
        <BookCarousel title="You Might Also Like" books={relatedBooks} />
      </div>
    </motion.div>
  );
};

export default BookDetails;
